export const ENV_URL = 'https://sdk-api.zhangyuqu.com/' // 支付/pay/pay接口用
export const API_URL = 'https://sdk-api.zhangyuqu.com/' // 手游后端
export const CAPTCHA_KEY = "FFFF0N0000000000B821" // 滑动验证码，没有启用
